import { render, staticRenderFns } from "./HorseAllActes.vue?vue&type=template&id=dc168790&"
import script from "./HorseAllActes.vue?vue&type=script&lang=js&"
export * from "./HorseAllActes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports